var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuelBwIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3196 4.68054L19.3165 8.67745L18.5719 9.42203L14.575 5.42513L15.3196 4.68054Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6464 2.35355C15.8417 2.15829 16.1583 2.15829 16.3536 2.35355L21.6464 7.64645C21.8417 7.84171 21.8417 8.15829 21.6464 8.35355L20.9393 9.06066C20.7441 9.25592 20.4275 9.25592 20.2322 9.06066L14.9393 3.76777C14.7441 3.5725 14.7441 3.25592 14.9393 3.06066L15.6464 2.35355Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 3C5.22386 3 5 3.22386 5 3.5V5H4V3.5C4 2.67157 4.67157 2 5.5 2H10.5C11.3284 2 12 2.67157 12 3.5V5H11V3.5C11 3.22386 10.7761 3 10.5 3H5.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C2.89543 5 2 5.89543 2 7V20C2 21.1046 2.89543 22 4 22H17C18.1046 22 19 21.1046 19 20V11.143C19 10.6129 18.7896 10.1045 18.4149 9.72946L16.3438 7.65625L14.2733 5.58579C13.8982 5.21071 13.3895 5 12.8591 5H4ZM12 9L7 15H9L8 19L13 13H11L12 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelBwIcon);
export default __webpack_public_path__ + "static/media/FuelBWIcon.0630799b.svg";
export { ForwardRef as ReactComponent };